'use strict';
import localforage from 'localforage';
import {stateGo} from 'redux-ui-router';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/take';
import {Observable} from 'rxjs/Observable';
import {asyncStorage} from '../../config/constants';
import {FIREBASE_TOKEN, PROFILE, REFRESH_TOKEN, TOKEN} from '../../config/constants/auth-keys';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {asyncStorage as reqListStorage} from '../../requirements/redux/config/reqListConfig';
import {logoutError, logoutSuccess, requestLogout} from '../actions';
import {getUserId} from '../reducers';
import {getLoginView} from '../router';
import {logger} from './logger';


export const epics = [
  onLogoutUser,
  onLogoutSuccess,
];

onLogoutUser.$inject = [
  'FirebaseUtil',
  'mobilePushService',
  '$ionicHistory',
  'authCacheService',
  'audioNotificationService',
];

export function onLogoutUser(action$, store, dependencies) {
  return action$.ofType(requestLogout.TYPE)
    .switchMap(() => {
      // dependencies.audioNotificationService.playLogout();

      try {
        dependencies.$ionicHistory.clearHistory();
      } catch (e) {
      }

      const userId = getUserId(store.getState());

      if (!userId) {
        return Observable.of(null);
      } else {
        return Observable
          .merge(
            Observable.fromPromise(dependencies.mobilePushService.disablePush(userId).catch(e => null)),
            Observable.timer(2500).mapTo(null),
          )
          .take(1);
      }
    })
    .switchMap(() => {
      try {
        // Clear existing auth data
        dependencies.authCacheService.removeItem(PROFILE);
        dependencies.authCacheService.removeItem(TOKEN);
        dependencies.authCacheService.removeItem(FIREBASE_TOKEN);
        dependencies.authCacheService.removeItem(REFRESH_TOKEN);

        // delete cached data
        if (global.window.localStorage) {
          global.window.localStorage.clear();
        }

        try {
          localforage.clear();
        } catch (e) {
        }

        try {
          asyncStorage.clear();
        } catch (e) {
        }

        try {
          reqListStorage.clear();
        } catch (e) {
        }

        // Log out the firebase client
        dependencies.FirebaseUtil.firebaseRef().unauth();

        return Observable.of(logoutSuccess());
      } catch (err) {
        return Observable.of(logoutError(err));
      }
    })
    .catch(epicErrorHandler(logger, 'onLogoutUser'));
}

// TODO: we should probably use the following state change success (or failure) action instead of a timer to delay the reload
export function onLogoutSuccess(action$) {
  return action$.ofType(logoutSuccess.TYPE)
    .mergeMap(() => {
      // send user to the login view, delay, then reload the page
      return Observable.merge(
        Observable.of(stateGo(getLoginView())),
        Observable.timer(1500)
          .map(() => {
            // This is mainly a stop-gap measure to cleanup AngularFire-util and AngularDomain memory leaks
            // We may be able to drop this epic once those 2 libraries have been successfully phased out.
            global.window.location.reload();
            return null;
          })
          .filter(() => false)
      );
    })
    .catch(epicErrorHandler(logger, 'onLogoutSuccess'));
}



// WEBPACK FOOTER //
// ./src/js/auth/epics/logoutUser.js